<template>
    <ExportTransformersViewReportPage
        v-if="componentTypeAsNumber === ComponentType.Transformer"
        :transformer-id="componentSid"
        :report-number="reportNumber"
        :report-type="reportType"
    />
    <ExportGeneratorsViewReportPage
        v-if="componentTypeAsNumber === ComponentType.Generator"
        :generator-id="componentSid"
        :report-number="reportNumber"
        :report-type="reportType"
    />
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import ExportTransformersViewReportPage from './transformers/ExportTransformersViewReportPage.vue'
import { ComponentType } from '@/configuration/component/component-types'
import ExportGeneratorsViewReportPage from './generators/ExportGeneratorsViewReportPage.vue'

const props = defineProps<{
    componentSid: string
    componentType: string
    reportNumber: string
    reportType: string
}>()

const { componentSid, componentType, reportNumber, reportType } = toRefs(props)

const componentTypeAsNumber = computed(() => Number(componentType.value))
</script>
